<template>
  <div>
    <v-container class="tab-header the-main-concept pb-25">
      <div class="d-flex justify-space-between align-center flex-col-xs">
        <div>
          <h1 v-if="accountInfo && accountInfo.user && accountInfo.user.id === loggedUser.id" >{{$t('my_account')}}</h1>
          <h1 v-else-if="isFriend">{{$t('products.friend')}}</h1>
          <h1 v-else>{{$t('accounts.user_profile')}}</h1>
        </div>
        <div>
          <div v-if="productRequests.length > 0" class="prod-request-note-sect __prod-request-note-sect p-0 flex-column-xs xs12">
            <v-layout
              class="main-position-sect main-position-friend ex-scroll">
              <v-flex class="prod-request-note">
                <v-list>
                  <template v-for="(item, index) in productRequests">
                    <v-list-tile three-line
                                 :key="item.id"
                                 avatar
                    >
                      <v-list-tile>
                        <router-link :to="/products/ + item.displayDetails.id + '/' + item.displayDetails.name.replace(/\s+/g, '-')">
                          <img v-if="item.image"
                               class="note-image"
                               height="50"
                               :src="apiUrl + item.image"
                               :alt="item.displayDetails.name">
                          <img v-else src="../../assets/images/image-icon.svg" alt="Product image">
                        </router-link>
                      </v-list-tile>
                      <v-list-tile-content class="need-message-sect  __need-message-sect flex md8 sm6 xs12">
                        <router-link :to="/products/ + item.displayDetails.id + '/' + item.displayDetails.name.replace(/\s+/g, '-')">
                          <v-list-tile-title v-html="item.displayDetails.name"/>
                        </router-link>
                        <v-list-tile-sub-title v-html="item.displayDetails.description"/>
                        <v-list-tile-sub-title v-html="item.message"/>
                      </v-list-tile-content>
                      <v-list-tile-action v-if="item.accepted !== null" class="flex status-message-info mr-20">
                        <v-list-tile-action-text v-if="item.accepted" class="accept-text">
                          <v-icon>icon-accept</v-icon>
                          {{$t('products.requestAccepted')}}
                        </v-list-tile-action-text>
                        <v-list-tile-action-text v-else class="decline-text">
                          <v-icon>icon-combined-shape-1</v-icon>
                          {{$t('products.requestRejected')}}
                        </v-list-tile-action-text>
                      </v-list-tile-action>
                      <v-list-tile-action v-if="item.accepted === null" class="accept-decline-prod-need flex mr-20">
                        <v-btn class="decline-need-btn" :ripple="false" @click="rejectRequest(item.id, false)" :disabled="isDisabled">{{$t('products.decline')}}
                          <v-icon>icon-remove-565</v-icon>
                        </v-btn>
                        <v-btn class="accept-need-btn" :ripple="false" @click="confirmRequest(item.id)">{{$t('products.accept')}}
                          <v-icon>icon-check</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-layout align-center justify-space-between class="contact-by-message" :key="`contactBy-${index}`" v-if="item.accepted === true">
                      <v-list-tile-title class="contact-by-message-info">
                        <span>{{item.displayDetails.contactBy}}</span>
                      </v-list-tile-title>
                    </v-layout>
                    <v-divider v-if="index +1 < productRequests.length" :key="`divider-${index}`"/>
                  </template>
                </v-list>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </div>
    </v-container>
    <v-container class="persons-account the-main-concept p-0">
      <div class="persons-content p-0">
        <v-layout row wrap v-if="accountInfo.user" class="top-offset p-0">
          <div class="d-flex w-100 flex-col-xs">
            <div>
              <v-flex class="person-info-sect1" xs12 sm12>
                <div class="avatarImg">
                  <img :src="avatar" :alt="$t('avatar')"/>
                </div>
                <v-btn v-show="accountInfo.user.id === loggedUser.id" :ripple="false" flat to="/profile/my-account"
                       class="edit-account-btn">{{$t('settings.edit_profile')}}
                </v-btn>
              </v-flex>
            </div>
            <div class="d-flex flex-row w-100 justify-space-between flex-column-xs">
              <v-flex class="person-info-sect2" md6 sm6 xs12>
                <h2>{{accountInfo.user.firstName}} {{accountInfo.user.lastName || ''}}</h2>
                <div class="friends-contact">
                  <p v-if="accountInfo.user.companyDetails">
                    {{$t('accounts.website')}}:
                    <span><a :href="accountInfo.user.companyDetails" target="_blank">{{accountInfo.user.companyDetails}}</a></span>
                  </p>
                  <div v-if="accountInfo.user.id === loggedUser.id || showDetails">
                    <p v-if="accountInfo.user.email">{{$t('email')}}: <span>{{accountInfo.user.email}}</span></p>
                    <p v-if="accountInfo.user.phoneNumber">{{$t('phone_number')}}: <span>{{accountInfo.user.phoneNumber}}</span></p>
                    <p v-if="accountInfo.user.dateBirthday">{{$t('date_of_birth')}}: <span>{{ accountInfo.user.dateBirthday | moment('calendar') }}</span>
                    </p>
                  </div>
                </div>
                <p class="about" v-if="accountInfo.user.about && (accountInfo.user.id === loggedUser.id || showDetails)">{{accountInfo.user.about}}</p>
              </v-flex>
              <v-flex xs12 sm6 md5 class="person-info-sect3">
                <div class="my-account-btn-sect" v-if="accountInfo.user.id === loggedUser.id">
                  <!--<span>{{$t('accounts.you')}}</span>-->
                  <v-btn flat :ripple="false" to="/profile/my-products" class="add-goods-btn">{{$t('products.add_new_goods')}}
                    <v-icon>icon-add</v-icon>
                  </v-btn>
                </div>
                <div class="btn-sect1" ref="tag" v-else-if="accountInfo.user.id !== loggedUser.id">
                  <!--When you logged to other user profile-->
                  <span class="friend-status-message" v-if="isFriendRequested">{{$t('accounts.friend_requested')}}</span>
                  <v-btn v-show="!isFriend" lat solo :ripple="false" class="add-friend-btn" v-else @click="addFriend">
                    {{$t('accounts.to_be_friend')}}
                    <span class="abs-icon">
                      <v-icon class="friend-req-icon" v-if="!loading">icon-friend-request</v-icon>
                      <v-icon class="loading-icon" v-if="loading">fa fa-spinner fa-pulse</v-icon>
                    </span>
                  </v-btn>

                  <v-btn v-if="isFriend" @click="deleteModal(accountInfo.user.id)" lat solo :ripple="false"
                         class="add-friend-btn">
                    {{ $t('accounts.delete_friend') }}
                    <span class="abs-icon">
                      <v-icon class="friend-req-icon">icon-delete</v-icon>
                    </span>
                  </v-btn>
                  <v-btn flat :ripple="false" to="/profile/my-groups" class="add-group-btn">{{$t('group.add_to_group')}}
                    <v-icon>icon-combined-shape</v-icon>
                  </v-btn>
                </div>
                <div class="btn-sect2" v-else-if="accountInfo.user.id !== loggedUser.id || isFriend">
                  <span>
                    <v-icon>icon-fill-1</v-icon>
                    {{$t('accounts.your_friend')}}
                  </span>
                  <v-btn flat :ripple="false" to="/profile/my-groups" class="add-group-btn">{{$t('group.add_to_group')}}
                    <v-icon>icon-combined-shape</v-icon>
                  </v-btn>
                </div>
                <div class="xs12 md4 d-flex  text-center person-product-status">
                  <div class="received">
                    <div class="d-flex justify-center">{{this.received}}</div>
                    <p class="d-flex">{{$t('received')}}</p>
                  </div>
                  <div class="given">
                    <div class="d-flex justify-center">{{this.given}}</div>
                    <p class="d-flex">{{$t('given')}}</p>
                  </div>
                </div>
              </v-flex>
            </div>
          </div>
        </v-layout>
      </div>
      <div v-if="accountInfo.user" class="locker-sector">
        <v-tabs v-show="isFriend || isProductRequested || accountInfo.user.id === loggedUser.id"
                class="flLeft ads-btn"
                hide-slider
        >
          <v-tab :ripple="false" class="received" @click="selectTab('my_ads')">
            {{$t('received')}}
          </v-tab>
          <v-tab :ripple="false" class="given" @click="selectTab('given')">
            {{$t('given')}}
          </v-tab>
        </v-tabs>
        <v-layout v-if="isFriend || isProductRequested || accountInfo.user.id === loggedUser.id"
                  align-center row wrap
                  pa-3 class="g-card products-status-list">
          <h3 v-if="items.length === 0" class="text-md-center">
            {{$t('no_matching_items_found')}}
          </h3>
          <v-flex lg3 sm6 md3 v-for="item in items" :key="item.id" :class="{ 'ex-height' : items.length <= 3 }"
                  class="g-product-list-item">
            <v-card flat class="product-description">
              <div class="g-item-list">
                <router-link v-if="item.image" :to="/products/ + item.id + '/' + item.displayDetails.name.replace(/\s+/g, '-')">
                  <img  class="g-card-img"
                        :src="`${ROOT_API}${item.image}`"
                        :alt="item.displayDetails.name">
                </router-link>
                <router-link v-else  :to="/products/ + item.id + '/' + item.displayDetails.name.replace(/\s+/g, '-')" >
                  <img class="g-card-img no-prod-img"
                       src="../../assets/images/image-icon.svg"
                       :alt="item.displayDetails.name">
                </router-link>
              </div>
              <v-container fluid class="prod-info">
                <v-layout fill-height class="g-header">
                  <v-flex xs12 align-center justify-space-between d-flex>
                    <span class="headline-title"> {{item.displayDetails.name }}</span>
                  </v-flex>
                </v-layout>
              </v-container>
              <v-card-title class="location-info" v-if="item.displayDetails && item.displayDetails.location">
                <v-list-tile-content>
                  <v-list-tile-sub-title class="location-info-sub-title">
                    <v-icon>icon-location</v-icon>
                    <span>{{item.displayDetails.location }}</span>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-card-title>
            </v-card>
          </v-flex>
        </v-layout>
        <div v-else class="lock-sect">
          <hr>
          <div class="not-received">
            <img class="lock" src="../../assets/images/lock.svg" alt="" width='100' height='100'>
            <p>{{$t('profile.capability_users_data')}}</p>
          </div>
        </div>
      </div>

      <v-dialog v-model="dialogConfirm" max-width="500px">
        <v-form ref="formConfirm" v-model="validConfirm" lazy-validation class="disable-form-contact">
          <v-card color="contact-with-user-modal">
            <v-card-title class="modal-close-btn-sect">
              <v-btn
                class="cancel-user-contact-modal-btn"
                :ripple="false"
                flat
                @click.native="close">
                <v-icon>icon-cancel</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-title class="text-md-center headline-title title-name">
              <span>{{$t('profile.contact_me')}}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-xs>
                <v-layout wrap class="chose-contact-type-sect">
                  <v-flex xs12 sm12 md12 class="contact-by-type-sect">
                    <v-layout align-flex-start justify-space-between class="type-cont-main-sect">
                      <v-checkbox v-model="enabledTel"
                                  :label="$t('profile.contact_by_phone')"
                                  color="#8890e4"
                                  class="shrink mr-2"/>
                      <v-text-field
                        :disabled="!enabledTel"
                        v-model="contactByTel"
                        :rules="contactByTelRules"
                        color="indigo"
                        class="shrink mr-2 type-input"
                        flat-rigth
                        solo
                        placeholder="+374XXXXXXXX"
                      />
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm12 md12 class="contact-by-type-sect">
                    <v-layout align-flex-start justify-space-between class="type-cont-main-sect">
                      <v-checkbox v-model="enabledEmail"
                                  :label="$t('profile.contact_by_email')"
                                  color="#8890e4"
                                  class="shrink mr-2"/>
                      <v-text-field
                        :disabled="!enabledEmail"
                        v-model="contactByEmail"
                        :rules="contactByEmailRules"
                        color="indigo"
                        class="shrink mr-2 type-input"
                        flat-rigth
                        solo
                      />
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions class="modal-btn-sect">
              <v-spacer></v-spacer>
              <v-btn class="cancel-request-btn2" :ripple="false" @click.native="close">{{$t('products.cancel')}}</v-btn>
              <v-btn class="send-request-btn" :ripple="false" @click.native="save" :disabled="!enabledTel && !enabledEmail">{{$t('products.send')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-container>
    <v-dialog v-model="dialog" max-width="550px">
      <v-card class="delete-friend-modal">
        <v-card-title  class="headline-title">
          <span>{{$t('accounts.delete_friend')}}</span>
        </v-card-title>
        <v-card-text class="delete-modal-text">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex>
                <span>{{$t('accounts.delete_friend_text')}}</span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions class="delete-friend-btn-sect">
          <v-btn flat :ripple="false" class="cancel-delete-btn" @click.native="closeModal">{{$t('accounts.cancel')}}</v-btn>
          <v-btn flat :ripple="false" @click.native="deleteFriend" class="accept-delete-btn">{{$t('accounts.delete')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import { changeImageSize, createLocation, validateEmail } from '../../helpers/main'
import NoImage from '../../assets/images/NoImage.png'
import { EventBus } from '../../event-bus'

export default {
  created () {
    this.getAllGroups()
    EventBus.$on('language-changed', this.languageChanged)
    this.getAccountInfo()
    this.getUnprocessedProducts()
    this.getReqProducts()
  },
  name: 'UserPage',
  props: ['roles'],
  data: () => ({
    deleteFriendId: null,
    dialog: false,
    canSee: null,
    canSeeAll: null,
    showFriend: null,
    friendCantSee: null,
    yourFriend: null,
    products: [],
    ROOT_API: process.env.ROOT_API,
    items: [],
    productsReceived: {},
    productsGiven: {},
    received: 0,
    given: 0,
    loading: false,
    apiUrl: process.env.ROOT_API,
    avatar: '',
    showDetails: false,
    isFriend: false,
    isFriendRequested: null,
    showEmailAndPhone: false,
    group: {
      addNewOneGroup: false,
      description: '',
      name: ''
    },
    groups: [],
    groupData: {
      groupId: ''
    },
    isProductRequested: false,
    productRequests: [],
    dialogConfirm: false,
    productId: null,
    enabledTel: false,
    contactByTel: '',
    enabledEmail: true,
    contactByEmail: '',
    validConfirm: true,
    isDisabled: false,
    disabledTimeout: 500,
    none: 'none',
    block: 'block',
    flex: 'flex'

  }),
  mounted () {
    let label = this.$refs.tag
    if (label) {
      label.style.display = this.none
    }
  },
  computed: {
    ...mapState({
      loggedUser: state => state.auth.userData,
      accountInfo: state => state.accounts.accountInfo
    }),
    nameRules () {
      return [
        v => !!v || this.$t('group.group_name_required')
      ]
    },
    contactByTelRules () {
      const rules = []
      if (this.enabledTel) {
        rules.push(v => !!v || this.$t('profile.phone_required'))
        rules.push(v => (!!v && /^\+?(?:[0-9] ?){7,14}[0-9]$/.test(v)) || this.$t('profile.phone_not_valid'))
      }
      return rules
    },
    contactByEmailRules () {
      const rules = []
      if (this.enabledEmail) {
        rules.push(v => !!v || this.$t('email_required'))
        rules.push(v => validateEmail(v) || this.$t('email_not_valid'))
      }
      return rules
    }
  },
  watch: {
    dialogConfirm (val) {
      val || this.close()
      this.$refs.formConfirm.resetValidation()
    },
    $route (to, from) {
      if (to.params && from.params) {
        this.getAllGroups()
        this.getAccountInfo()
        this.getUnprocessedProducts()
        this.getReqProducts()
      }
    }
  },
  methods: {
    addFriend () {
      if (this.accountInfo.user.id === this.loggedUser.id) {
        this.$toastr('warning', this.$root.$t('accounts.cannot_send_invitation_to_you'), this.$root.$t('warning'))
        return false
      }
      this.loading = true
      const data = {
        userId: this.accountInfo.user.id || this.$route.params.userId,
        email: this.accountInfo.user.email,
        firstName: this.loggedUser.firstName,
        lastName: this.loggedUser.lastName,
        inviterMail: this.loggedUser.email
      }
      this.$store.dispatch('profile/sendInvitationToFriend', data).then(response => {
        this.$toastr(response.type, response.message, this.$root.$t(response.type))
        this.loading = false
        if (response.type === 'success') {
          this.isFriendRequested = true
        }
      }).catch(err => {
        console.log(err)
      })
    },
    deleteFriend () {
      if (this.deleteFriendId) {
        this.$store.dispatch('profile/deleteFriend', this.deleteFriendId).then(response => {
          this.$toastr(response.type, response.message, this.$t(response.type))
          this.isFriendRequested = false
          this.isFriend = false
        }).catch(err => {
          console.log(err)
        })
      }
      this.closeModal()
    },
    deleteModal (friendId) {
      this.deleteFriendId = friendId
      this.dialog = true
    },
    closeModal () {
      this.dialog = false
    },
    selectTab (product) {
      if (product === 'given') {
        if (this.productsGiven.length) {
          this.products = JSON.parse(JSON.stringify(this.productsGiven))
          this.getProductList(this.products)
        } else {
          this.items = []
        }
      } else if (product === 'my_ads') {
        if (this.productsReceived.length) {
          this.products = JSON.parse(JSON.stringify(this.productsReceived))
          this.getProductList(this.products)
        } else {
          this.items = []
        }
      }
    },
    getProductList (products) {
      let _products = []
      products.forEach(product => {
        product.image = changeImageSize(product.image, 'md')
        product.displayDetails = {}
        product.ProductTranslations.forEach(productTranslation => {
          if (productTranslation.languageId === this.$store.getters['common/getActiveLanguage'].id) {
            product.displayDetails.name = productTranslation.name
            product.displayDetails.description = productTranslation.description
          } else if (!product.displayDetails.name) {
            product.displayDetails.name = productTranslation.name
            product.displayDetails.description = productTranslation.description
          }
        })
        product.ProductAddresses.forEach(productAddress => {
          let addressData = productAddress.Address
          if (productAddress.languageId === this.$store.getters['common/getActiveLanguage'].id) {
            product.displayDetails.location = createLocation(addressData)
          } else if (!product.displayDetails.location) {
            product.displayDetails.location = createLocation(addressData)
          }
        })
        _products.push(product)
        this.items = _products
      })
    },
    getRequestList (requests) {
      let _requests = []
      requests.forEach(request => {
        request.image = changeImageSize(request.Product.image, 'md')
        request.displayDetails = {
          id: request.Product.id
        }
        request.Product.ProductTranslations.forEach(productTranslation => {
          if (productTranslation.languageId === this.$store.getters['common/getActiveLanguage'].id) {
            request.displayDetails.name = productTranslation.name
            request.displayDetails.description = productTranslation.description
          } else if (!request.displayDetails.name) {
            request.displayDetails.name = productTranslation.name
            request.displayDetails.description = productTranslation.description
          }
        })

        if (request.options) {
          let contactBy = this.$root.$t('profile.contact_by')
          if (request.options.byTel && request.options.byEmail) {
            contactBy = contactBy + this.$root.$t('profile.phone') + request.options.byTel + this.$root.$t('profile.or') + this.$root.$t('profile.email') + request.options.byEmail
          } else {
            contactBy = contactBy + (request.options.byTel ? (this.$root.$t('profile.phone') + request.options.byTel) : (this.$root.$t('profile.email') + request.options.byEmail))
          }
          request.displayDetails.contactBy = contactBy
        }
        _requests.push(request)
      })
      this.productRequests = _requests
    },
    languageChanged () {
      this.getProductList(this.products)
      this.getRequestList(this.productRequests)
      this.getAllGroups()
    },
    getUnprocessedProducts () {
      this.$store.dispatch('accounts/getProductsRequestsByUserId', {userId: this.$route.params.userId})
        .then((res) => {
          this.given = res.givenProducts.length
          this.received = res.receivedProducts.length
          this.items = res.productsReceived
          this.productsReceived = res.productsReceived
          this.productsGiven = res.productsGiven
          this.products = JSON.parse(JSON.stringify(this.items))
          this.getProductList(this.products)
          this.getRequestList(res.productRequests)
        }).catch(console.error)
    },
    addNewGroup () {
      if (this.group.name) {
        this.$store.dispatch('groups/add', {name: this.group.name})
          .then(response => {
            this.groupData.groupId = response.groupId
            console.log(response)
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    getAllGroups () {
      this.$store.dispatch('groups/getAllGroups').then((res) => {
        // let _groupsData = []
        if (res.groups) {
          // res.groups.forEach(group => {
          //   let groupsData = {}
          //   groupsData.name = group.displayData.name
          //   groupsData.id = group.id
          //   _groupsData.push(groupsData)
          this.groups = res.groups
          // })
        }
        // this.groups = _groupsData
      })
    },
    openAddNewGroup () {
      this.group.addNewOneGroup = true
    },
    addFriendInGroup () {
      this.group.addNewOneGroup = false
      if (this.groupData.groupId) {
        this.$store.dispatch('groups/addFriendInGroup', {groupId: this.groupData.groupId, userId: +this.$route.params.userId})
          .then(response => {
            console.log('friendGroup', response)
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    getReqProducts () {
      this.$store.dispatch('products/getProductRequests')
        .then((res) => {
          if (res.productReqUserIds) {
            if (res.productReqUserIds.indexOf(+this.$route.params.userId) !== -1) {
              this.isProductRequested = true
            }
          }
        })
    },
    rejectRequest (id, accept) {
      this.acceptRequest(id, accept)
    },
    confirmRequest (id) {
      if (this.loggedUser) {
        this.contactByTel = this.loggedUser.phoneNumber
        this.contactByEmail = this.loggedUser.email
      }
      this.productId = id
      this.dialogConfirm = true
    },
    acceptRequest (id, accept) {
      if (this.isDisabled) {
        return
      }
      this.isDisabled = true
      let data = {}
      data.id = id
      data.accept = accept
      if (this.enabledTel && this.contactByTel) {
        data.contactByTel = this.contactByTel
      }
      if (this.enabledEmail && this.contactByEmail) {
        data.contactByEmail = this.contactByEmail
      }
      this.$store.dispatch('products/acceptRequest', data).then((response) => {
        setTimeout(() => {
          this.isDisabled = false
        }, this.disabledTimeout)
        this.$toastr(response.type, response.message, this.$root.$t(response.type))
        this.getUnprocessedProducts()
      }).catch(console.error)
    },
    close () {
      this.dialogConfirm = false
      setTimeout(() => {
        this.productId = null
      }, 300)
    },
    save () {
      if (this.$refs.formConfirm.validate()) {
        this.acceptRequest(this.productId, true)
        this.close()
      }
    },
    getAccountInfo () {
      this.$store.dispatch('accounts/accountInfo', {userId: this.$route.params.userId})
        .then((res) => {
          if (!this.accountInfo.user) {
            this.$router.push('/')
            return false
          }
          this.isFriend = this.accountInfo.isFriend
          this.isFriendRequested = this.accountInfo.isFriendRequested
          if (this.isFriend !== true) {
            this.isFriend = false
          }
          if (this.isFriendRequested !== true) {
            this.isFriendRequested = false
          }
          if (this.accountInfo.user.image) {
            this.avatar = this.apiUrl + changeImageSize(this.accountInfo.user.image, 'md')
          }
          if (!this.accountInfo.user.image) {
            this.avatar = changeImageSize(NoImage, 'md')
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    whoCanSeeAccount () {
      let accountId = this.$route.params.userId
      if (this.loggedUser.id !== parseInt(this.$route.params.userId && accountId)) {
        let data = {
          loggedUserId: this.loggedUser.id,
          userId: accountId
        }
        this.$store.dispatch('accounts/whoCanSeeAccount', data).then((response) => {
          if (response) {
            let label = this.$refs.tag
            if (label) {
              label.style.display = this.block
              label.style.display = this.flex
            }
            this.showDetails = response.showDetails || false
            this.isFriend = response.isFriend || false
          }
        }).catch(console.error)
      }
    }
  },
  beforeUpdate () {
    this.whoCanSeeAccount()
  }
}
</script>

<style lang="scss">
@import "../../assets/sass/desktop/accountsPage.scss";
@import "../../assets/sass/desktop/notificationPage.scss";  /* todo need to moving formConfirm modals styles to another CSS file for modal and remove this line*/
</style>



// WEBPACK FOOTER //
// src/components/AccountsPage/UserPage.vue